<template>
  <button
    :disabled="disabled"
    class="button-base"
    :class="[
      { primary: !secondary && !borderless },
      { secondary: secondary },
      { borderless: borderless },
    ]"
    @click="onClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'cw-button',
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    secondary: {
      type: Boolean,
      default: false,
      required: false,
    },
    borderless: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="stylus">

  cw-primary-color = #f00;

  if dark(cw-primary-color) {
    cw-primary-hover-color = cw-primary-color + 30%;
  }
  else {
    cw-primary-hover-color = cw-primary-color - 15%;
  }

  .button-base {
    border-width: 0.1rem;
    border-style: solid;
    border-color: cw-primary-color;
    border-radius: 999rem;
    background: transparent;
    cursor: pointer;
    font-size: 1rem;
    padding: 1rem 2rem;
    margin: 10px;
    min-height: 3.5rem;
    outline: 0;

    &:disabled,
    &.secondary:disabled,
    &.borderless:disabled,
    &.button-base:hover:disabled,
    &.secondary:hover:disabled,
    &.borderless:hover:disabled {
      border-color: #ccc;
      cursor: not-allowed;
    }

    &.primary {
      background-color: cw-primary-color;
      color: #fff;

      &:hover {
        background-color: cw-primary-hover-color;
      }

      &:disabled {
        background: #ccc;
        color: #fff;
      }
    }

    &.secondary {
      border-color: cw-primary-color;
      color: cw-primary-color;

        &:hover {
          background-color: cw-primary-color;
          color: #fff;
        }
        &:disabled,
        &:disabled:hover {
          color: #ccc;
          background: transparent;
        }
    }
    &.borderless {
      padding: 0;
      border-width: 0;
      color: cw-primary-color;
      &:disabled {
        color: #ccc;
      }
    }
}
</style>
